import axios from 'axios';
import {getOSSObjectURLFromURN} from '../util/oss-helpers';

const getSignedS3DownloadUrl = ({urn, token, acmHeaders}) =>
  axios.get(`${getOSSObjectURLFromURN(urn)}/signeds3download`, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...acmHeaders
    }
  });

const getSignedS3UploadUrl = ({urn, token, acmHeaders}) =>
  axios.get(`${getOSSObjectURLFromURN(urn)}/signeds3upload`, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...acmHeaders
    }
  });

const finalizeS3Upload = ({urn, token, uploadKey, acmHeaders}) =>
  axios.post(
    `${getOSSObjectURLFromURN(urn)}/signeds3upload`,
    {uploadKey},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        ...acmHeaders
      }
    }
  );

const uploadBinaryData = ({url, data, config}) => axios.put(url, data, config);

export default {
  getSignedS3DownloadUrl,
  getSignedS3UploadUrl,
  finalizeS3Upload,
  uploadBinaryData
};
